'use client';
import React from 'react';
import { Settings, Package, Ruler, ShieldCheck, Factory } from 'lucide-react';

const ServiceSpecs = ({ specs }) => {
    return (
        <section className="py-20 bg-[#f8fafc] border-y border-slate-200">
            <div className="w-full max-w-[1240px] mx-auto px-4 sm:px-6 lg:px-0">
                <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
                    {/* Left Column: Context */}
                    <div className="w-full lg:w-1/3 flex flex-col items-start text-left">
                        <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center mb-6">
                            <Settings size={24} />
                        </div>
                        <h2 className="text-3xl md:text-4xl font-bold text-[#1D2B4F] mb-6">
                            Technical Specs at a Glance
                        </h2>
                        <p className="text-lg text-[#5A6782] mb-8 leading-relaxed">
                            Essential procurement data and manufacturing parameters designed to help you qualify our production capabilities instantly.
                        </p>
                        
                        {/* Highlights */}
                        <div className="flex flex-col gap-4">
                            <div className="flex items-center gap-4 bg-white p-4 rounded-xl border border-slate-100 shadow-sm">
                                <Package className="text-blue-500" size={24} />
                                <div>
                                    <p className="text-xs text-slate-400 font-bold uppercase tracking-wider">Sample Policy</p>
                                    <p className="font-semibold text-slate-800">{specs.sampleAvailability || 'Available upon request'}</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-4 bg-white p-4 rounded-xl border border-slate-100 shadow-sm">
                                <Factory className="text-indigo-500" size={24} />
                                <div>
                                    <p className="text-xs text-slate-400 font-bold uppercase tracking-wider">Compliance</p>
                                    <p className="font-semibold text-slate-800">{specs.complianceStandards || 'ISO 9001:2015, GMP'}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column: Spec Table */}
                    <div className="w-full lg:w-2/3 bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="w-full text-left border-collapse">
                                <tbody>
                                    {specs.data.map((row, index) => (
                                        <tr key={index} className={`border-b border-slate-100 last:border-b-0 hover:bg-slate-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50/50'}`}>
                                            <th className="py-4 px-6 text-sm font-bold text-slate-900 w-1/3 align-top">
                                                {row.label}
                                            </th>
                                            <td className="py-4 px-6 text-sm text-slate-600 align-top">
                                                {row.value}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceSpecs;
